// extracted by mini-css-extract-plugin
module.exports = {"seasons":"TVDetailSeasons_seasons__Uujhd","episodes":"TVDetailSeasons_episodes__cqmr9","no-episodes":"TVDetailSeasons_no-episodes__D1nOU","error":"TVDetailSeasons_error__1Rhg4"};